/** 后端时间字段统一是 RFC3339（如 2026-10-03T12:00:00+08:00）。 */

const pad = (n: number): string => String(n).padStart(2, '0')

/** 格式化为本地时区的 `YYYY-MM-DD HH:mm`，空值返回 fallback。 */
export function formatDateTime(value: string | null | undefined, fallback = '—'): string {
  if (!value) return fallback
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return fallback
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
    ` ${pad(d.getHours())}:${pad(d.getMinutes())}`
  )
}

/** 格式化为 `YYYY-MM-DD`，空值返回 fallback。 */
export function formatDate(value: string | null | undefined, fallback = '—'): string {
  return formatDateTime(value, fallback).slice(0, 10)
}

/**
 * 到期时间的展示文案：未设置即永不过期。
 * 已过期与 7 天内到期都要能被一眼看出，所以额外返回紧急度。
 */
export type ExpiryLevel = 'none' | 'ok' | 'soon' | 'expired'

export function expiryLevel(value: string | null | undefined, now = new Date()): ExpiryLevel {
  if (!value) return 'none'
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return 'none'
  const ms = d.getTime() - now.getTime()
  if (ms <= 0) return 'expired'
  if (ms <= 7 * 24 * 3600 * 1000) return 'soon'
  return 'ok'
}

/** 到期时间文案 + 紧急度，供表格 Tag 使用。 */
export function expiryText(
  value: string | null | undefined,
  now = new Date(),
): { text: string; level: ExpiryLevel } {
  const level = expiryLevel(value, now)
  if (level === 'none') return { text: '永不过期', level }
  if (level === 'expired') return { text: `已过期 ${formatDate(value)}`, level }
  if (level === 'soon') return { text: `${formatDate(value)} 到期`, level }
  return { text: formatDate(value), level }
}